module.exports = __webpack_public_path__ + "static/media/icon-envelope-red.f23a07e7.svg";